import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RequireAuth from './RequireAuth';
import ShellLayout from '../layout/ShellLayout';

// BAR-40: the OUTER route tree. RequireAuth (auth guard) wraps the pathless
// ShellLayout, which renders `legacyAuthedView` through its <Outlet/>.
//
// `legacyAuthedView` is the persistent shell (MainApplicationUI) — the chrome
// (sidebar / header / canvas frame / chat panel / modals), built in App with
// its closure and passed in as an element so its props survive. It renders the
// real view route table, <ShellRoutes>, as a DESCENDANT <Routes>.
//
// Two `path="*"` exist but they are LAYERED, not competing:
//   - This OUTER `*` matches every authed URL → always renders the shell, so
//     the chrome never remounts on navigation (only ShellRoutes' output swaps).
//   - The INNER `*` (inside ShellRoutes) is what selects the view and redirects
//     unknown paths to landing. Because ShellRoutes is a descendant of this
//     catch-all, it sees the full pathname and wins for every URL. (Verified in
//     routing.test.tsx, both as a root <Routes> and nested under path="*".)
export default function AppRoutes({ legacyAuthedView }: { legacyAuthedView: React.ReactNode }) {
  return (
    <Routes>
      <Route element={<RequireAuth />}>
        <Route element={<ShellLayout />}>
          <Route path="*" element={<>{legacyAuthedView}</>} />
        </Route>
      </Route>
    </Routes>
  );
}
